import _ from 'lodash';

type Template = (data?: Record<string, unknown>) => string;
export type UseHandlebarsHook = (input: string) => {
  template: Template;
};

/**
 * Handlebars hook
 */
const useHandlebars: UseHandlebarsHook = (input) => {
  const re = /\{{(.*?)\}}/g;
  const paths: Array<string> = input.match(re) || [];

  const template: Template = (data) =>
    paths.reduce(
      (acc, path) =>
        acc.replace(
          path,
          _.get(data, path.replace('{{', '').replace('}}', '')) as string,
        ),
      input,
    );

  return { template };
};

export default useHandlebars;
